import React from 'react';
import { useTranslation } from 'react-i18next';
import './AboutPage.css';

const AboutPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="about-page">
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">{t('about.title')}</h1>
          <p className="page-subtitle">{t('about.description')}</p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-card">
            <h2 className="mission-title">{t('home.mission')}</h2>
            <p className="mission-description">{t('home.description')}</p>
            <p className="mission-expectation">{t('home.expectation')}</p>
          </div>
        </div>

        <div className="container">
          <div className="values-section">
            <h2 className="values-title">{t('about.values')}</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-number">01</div>
                <h3 className="value-title">{t('home.feature1Title')}</h3>
                <p className="value-description">{t('home.feature1Description')}</p>
              </div>
              <div className="value-card">
                <div className="value-number">02</div>
                <h3 className="value-title">{t('home.feature2Title')}</h3>
                <p className="value-description">{t('home.feature2Description')}</p>
              </div>
              <div className="value-card">
                <div className="value-number">03</div>
                <h3 className="value-title">{t('home.feature3Title')}</h3>
                <p className="value-description">{t('home.feature3Description')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;

